/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscrepancyResponse } from '../../models/discrepancy-response';
import { KeyType } from '../../models/key-type';

export interface GetDiscrepancy$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
  discrepancyKey: KeyType;
}

export function getDiscrepancy(http: HttpClient, rootUrl: string, params: GetDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscrepancyResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscrepancy.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('discrepancyKey', params.discrepancyKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscrepancyResponse>;
    })
  );
}

getDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancies/{discrepancyKey}';
